import { render, staticRenderFns } from "./OpenOrder.vue?vue&type=template&id=5afac2f4&scoped=true"
import script from "./OpenOrder.vue?vue&type=script&lang=js"
export * from "./OpenOrder.vue?vue&type=script&lang=js"
import style0 from "./OpenOrder.vue?vue&type=style&index=0&id=5afac2f4&prod&lang=scss"
import style1 from "./OpenOrder.vue?vue&type=style&index=1&id=5afac2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afac2f4",
  null
  
)

export default component.exports